/**
 * productStore
 * 编辑页面共用逻辑以及部分子组件与父组件通讯
 */
import orderBackCountUtil from '../../../static/js/backCountUtils/orderBackCountUtil'

class ProductStore {
  constructor(product, initialState = {}, initialMutations, initialActions) {
    this.product = product

    //状态数据
    this.states = {
      formData: null, //表单信息
      showRouter: 'first', //跳转的路径
      detailModel: 0, //组件的模式   0 代表组套 默认是第一个  1 代表的是商品
      goodCartLists: [], //购物车数据
      detailData: {}, //详情信息
      cartNumber: 0, //购物车数量
      type: { code: 'goods', name: '商品' }, //类型为商品
      order: { id: '', code: '' }, //完成订单的信息
    }

    //修改states的方法
    this.mutations = {
      setFormData(states, data) {
        this.states.formData = data
        this.states.goodCartLists = data.items
        this.states.cartNumber = this.states.goodCartLists.reduce((prev, cur) => {
          return prev + cur.amount
        }, 0)
      },
      //更新formData
      updateFormData(states, data) {
        this.states.formData = data
      },
      //单个添加购物车
      addCart(states, data) {
        const [value, type, amount] = [...data]
        const index = this.states.goodCartLists.findIndex((item) => {
          return item.id == value.id
        })
        if (index !== -1) {
          if (type == 'single') {
            this.states.goodCartLists[index].amount++
          }
          if (type == 'multiple') {
            this.states.goodCartLists[index].amount += amount
          }
        } else {
          value.amount = 1
          this.states.goodCartLists.push(value)
        }
        this.commit('dataTransfer', this.states.goodCartLists)
        this.product.$Message.success('添加成功')
      },
      //批量添加购物车
      batchAddCart(states, data) {
        const [value, amount] = [...data]
        this.commit('addCart', [value, 'multiple', amount])
      },

      //添加虚拟包商品到购物车
      addGoodsToCart(states, data) {
        data.packageTemplateItems.forEach((element) => {
          let cartItems = Object.assign({}, data.packageTemplate)
          cartItems.code = element.goodsDetail.code
          cartItems.id = element.goodsDetail.id
          cartItems.name = element.goodsDetail.name
          cartItems.amount = element.amount ? element.amount : 1
          cartItems.model = element.goodsDetail.model
          cartItems.unit = element.unit
          cartItems.manufacturer = element.goodsDetail.manufacturer
          cartItems.type = this.states.type
          const index = this.states.goodCartLists.findIndex((item) => {
            return item.id == element.goodsDetail.id
          })
          if (index !== -1) {
            this.states.goodCartLists[index].amount += element.amount
          } else {
            this.states.goodCartLists.push(cartItems)
          }
        })

        this.commit('dataTransfer', this.states.goodCartLists)
        this.product.$Message.success('添加成功')
      },
      //添加单独的商品去购物车
      addSignleToCart(states, data) {
        let cartItems = {}
        cartItems.code = data.code
        cartItems.id = data.id
        cartItems.name = data.name
        cartItems.manufacturer = data.manufacturer
        cartItems.model = data.model
        cartItems.unit = data.unit
        cartItems.type = this.states.type
        const index = this.states.goodCartLists.findIndex((item) => {
          return item.id == data.id
        })
        if (index !== -1) {
          this.states.goodCartLists[index].amount++
        } else {
          cartItems.amount = 1
          this.states.goodCartLists.push(cartItems)
        }
        this.commit('dataTransfer', this.states.goodCartLists)
        this.product.$Message.success('添加成功')
      },
      dataTransfer(states, data) {
        data.forEach((ele) => {
          if (!ele.goods) {
            ele.goods = {}
            ele.goods.id = ele.id
            ele.goods.code = ele.code
            ele.goods.name = ele.name
            ele.goods.model = ele.model
            ele.goods.unit = ele.unit
          }
          if (ele.itemId) {
            ele.goods.model = ele.model
            ele.goods.unit = ele.unit
          }
        })
        this.states.cartNumber = this.states.goodCartLists.reduce((prev, cur) => {
          return prev + cur.amount
        }, 0)
      },

      //合并购物车的数据   //这里的逻辑复杂了 其实所有的添加 最后应该统一处理 不管前面增加了多少 最后统一处理
      mergeGoodsList() {
        const oldArr = []
        const newArr = []
        this.states.goodCartLists.forEach((item) => {
          if (item.itemId) {
            oldArr.push(item)
          } else {
            newArr.push(item)
          }
        })
        newArr.forEach((item) => {
          const index = oldArr.findIndex((ol) => ol.goods.id == item.id)
          if (index == -1) {
            oldArr.push(item)
          } else {
            oldArr[index].amount += item.amount
          }
        })
        this.states.goodCartLists.length = 0
        this.states.goodCartLists = [...oldArr]
        this.commit('dataTransfer', this.states.goodCartLists)
      },

      //清空购物车
      clearCart() {
        this.states.goodCartLists = []
        this.states.cartNumber = 0
      },
      //删除购物车数据
      deleteCart(states, data) {
        if (data.length == this.states.goodCartLists.length) {
          this.states.goodCartLists = []
        } else {
          this.states.goodCartLists = this.states.goodCartLists.filter((item) => {
            return !data.includes(item.goods.id)
          })
        }
        this.states.cartNumber = this.states.goodCartLists.reduce((prev, cur) => {
          return prev + cur.amount
        }, 0)
      },
    }
    //操作方法
    this.actions = {
      //触发单据类的反算
      orderBackCountUtil(context, field, ...args) {
        if (orderBackCountUtil[field] && typeof orderBackCountUtil[field] == 'function') {
          if (field == 'attrs.valueText.discount') {
            this.dispatch('updatePriceItem', field, ...args)
          } else {
            return orderBackCountUtil[field](...args)
          }
        }
      },
    }

    //初始赋值自定义state
    for (let prop in initialState) {
      if (initialState.hasOwnProperty(prop) && this.states.hasOwnProperty(prop)) {
        this.states[prop] = initialState[prop]
      }
    }

    //初始赋值自定义mutations
    for (let prop in initialMutations) {
      if (initialMutations.hasOwnProperty(prop)) {
        this.mutations[prop] = initialMutations[prop]
      }
    }

    //初始赋值自定义actions
    for (let prop in initialActions) {
      if (initialActions.hasOwnProperty(prop)) {
        this.actions[prop] = initialActions[prop]
      }
    }
  }

  commit(name, ...args) {
    const mutations = this.mutations
    if (mutations[name]) {
      mutations[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }

  dispatch(name, ...args) {
    const actions = this.actions
    if (actions[name]) {
      return actions[name].apply(this, [this].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }
}

export default ProductStore
